"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGLineChart = void 0;
const react_1 = __importStar(require("react"));
const line_1 = require("@nivo/line");
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const configContext_1 = require("../../../contexts/configContext");
const common_1 = require("./common");
const TGLineChart = (props) => {
    // TODO: [S5-3587] Consolidate inline props with `defaultProps` to facilitate options/value property merging with default values.
    const chartProps = (0, react_1.useMemo)(() => (0, common_1.mergeChartProps)(props, SAMPLE_PROPS), [props]);
    const { data, legendPosition, colorPalette: colorPaletteName } = chartProps;
    const { colorPalettes, defaultDateTimeFormat, primaryPalette } = (0, configContext_1.useConfig)();
    const colors = (0, react_1.useMemo)(() => { var _a, _b, _c; return (_c = (_b = (_a = colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.find(x => x.name === colorPaletteName)) === null || _a === void 0 ? void 0 : _a.colors) !== null && _b !== void 0 ? _b : primaryPalette) !== null && _c !== void 0 ? _c : undefined; }, [colorPalettes, colorPaletteName]);
    const { dateFormat, dateTimeFormat } = (0, react_1.useMemo)(() => ({
        dateFormat: (0, gen5_shared_utilities_1.getDateFormat)(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, { datePartOnly: true, tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MomentJS }),
        dateTimeFormat: (0, gen5_shared_utilities_1.getDateTimeFormat)(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.timeFormat, { tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MomentJS }),
    }), [defaultDateTimeFormat]);
    const { isXAxisDate, isYAxisDate } = (0, react_1.useMemo)(() => data.reduce((acc, serie) => {
        var _a, _b;
        return ({
            isXAxisDate: acc.isXAxisDate || ((_a = serie.data) === null || _a === void 0 ? void 0 : _a.some(d => (0, lodash_1.isDate)(d.x))),
            isYAxisDate: acc.isYAxisDate || ((_b = serie.data) === null || _b === void 0 ? void 0 : _b.some(d => (0, lodash_1.isDate)(d.y))),
        });
    }, { isXAxisDate: false, isYAxisDate: false }), [data]);
    const formatDateValue = (value) => {
        const local = (0, moment_1.default)(value);
        return local.millisecond() === 0 ? moment_1.default.utc(value).format(dateFormat) : local.format(dateTimeFormat);
    };
    // TODO: [S5-3587] Should we instead filter and show what we can?
    const hasMissingSerieData = (0, react_1.useMemo)(() => data.reduce((prev, curr) => {
        var _a;
        return prev || !((_a = curr.data) === null || _a === void 0 ? void 0 : _a.length);
    }, false), [data]);
    if (hasMissingSerieData) {
        return react_1.default.createElement("div", null, "No results");
    }
    // TODO: [S5-3487] Issue with React 18? https://stackoverflow.com/questions/71841181/some-components-cannot-be-used-as-a-jsx-component
    // @ts-ignore
    return react_1.default.createElement(line_1.ResponsiveLine, Object.assign({ colors: colors, margin: Object.assign({ top: 50, left: 60 }, (legendPosition === 'bottom' ? {
            right: 50,
            bottom: 80,
        } : {
            right: 110,
            bottom: 50,
        })), xScale: {
            type: isXAxisDate ? 'time' : 'point',
            nice: true,
        }, xFormat: isXAxisDate ? formatDateValue : undefined, yScale: {
            type: isYAxisDate ? 'time' : 'linear',
            nice: true,
            min: 'auto',
            max: 'auto',
        }, yFormat: isYAxisDate ? formatDateValue : " >-.2f", axisTop: null, axisRight: null, axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -20,
            truncateTickAt: 0,
            format: isXAxisDate ? formatDateValue : undefined,
        }, axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            truncateTickAt: 0,
            format: isYAxisDate ? formatDateValue : undefined,
        }, pointSize: 10, pointColor: { theme: 'background' }, pointBorderWidth: 2, pointBorderColor: { from: 'serieColor' }, pointLabel: "data.yFormatted", pointLabelYOffset: -12, enableTouchCrosshair: true, useMesh: true, legends: data.length > 1 ? [
            Object.assign(Object.assign({}, (legendPosition === 'bottom' ? {
                anchor: 'bottom',
                direction: 'row',
                translateX: 0,
                translateY: 56,
            } : {
                anchor: 'bottom-right',
                direction: 'column',
                translateX: 100,
                translateY: 0,
            })), { justify: false, itemsSpacing: 0, itemDirection: 'left-to-right', itemWidth: 80, itemHeight: 20, itemOpacity: 0.75, symbolSize: 12, symbolShape: 'circle', symbolBorderColor: 'rgba(0, 0, 0, .5)', effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1,
                        },
                    },
                ] }),
        ] : [] }, chartProps));
};
exports.TGLineChart = TGLineChart;
const SAMPLE_PROPS = {
    data: [{ "id": "Series A", "data": [{ "x": "Group A", "y": 292 }, { "x": "Group B", "y": 154 }, { "x": "Group C", "y": 28 }, { "x": "Group D", "y": 243 }, { "x": "Group E", "y": 57 }, { "x": "Group F", "y": 154 }, { "x": "Group G", "y": 253 }, { "x": "Group H", "y": 272 }, { "x": "Group I", "y": 31 }, { "x": "Group J", "y": 279 }, { "x": "Group K", "y": 170 }, { "x": "Group L", "y": 170 }] }, { "id": "Series B", "data": [{ "x": "Group A", "y": 1 }, { "x": "Group B", "y": 189 }, { "x": "Group C", "y": 54 }, { "x": "Group D", "y": 177 }, { "x": "Group E", "y": 99 }, { "x": "Group F", "y": 86 }, { "x": "Group G", "y": 146 }, { "x": "Group H", "y": 51 }, { "x": "Group I", "y": 269 }, { "x": "Group J", "y": 3 }, { "x": "Group K", "y": 238 }, { "x": "Group L", "y": 1 }] }, { "id": "Series C", "data": [{ "x": "Group A", "y": 130 }, { "x": "Group B", "y": 51 }, { "x": "Group C", "y": 106 }, { "x": "Group D", "y": 136 }, { "x": "Group E", "y": 288 }, { "x": "Group F", "y": 158 }, { "x": "Group G", "y": 146 }, { "x": "Group H", "y": 232 }, { "x": "Group I", "y": 208 }, { "x": "Group J", "y": 101 }, { "x": "Group K", "y": 170 }, { "x": "Group L", "y": 242 }] }, { "id": "Series D", "data": [{ "x": "Group A", "y": 229 }, { "x": "Group B", "y": 70 }, { "x": "Group C", "y": 277 }, { "x": "Group D", "y": 24 }, { "x": "Group E", "y": 292 }, { "x": "Group F", "y": 118 }, { "x": "Group G", "y": 2 }, { "x": "Group H", "y": 117 }, { "x": "Group I", "y": 105 }, { "x": "Group J", "y": 112 }, { "x": "Group K", "y": 186 }, { "x": "Group L", "y": 89 }] }, { "id": "Series E", "data": [{ "x": "Group A", "y": 77 }, { "x": "Group B", "y": 195 }, { "x": "Group C", "y": 114 }, { "x": "Group D", "y": 177 }, { "x": "Group E", "y": 125 }, { "x": "Group F", "y": 290 }, { "x": "Group G", "y": 211 }, { "x": "Group H", "y": 231 }, { "x": "Group I", "y": 7 }, { "x": "Group J", "y": 108 }, { "x": "Group K", "y": 267 }, { "x": "Group L", "y": 291 }] }],
    curve: undefined,
};
exports.default = exports.TGLineChart;
//# sourceMappingURL=TGLineChart.js.map